import { render, staticRenderFns } from "./BarNavBack.vue?vue&type=template&id=42653c2e&"
import script from "./BarNavBack.vue?vue&type=script&lang=js&"
export * from "./BarNavBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports